import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import CreateProject from "./Components/Dashboard/CreateProject/createProject";
import Summary from "./Components/Dashboard/Summary/summary";
import MyCustomer from "./Components/Dashboard/Customer&Settings/myCustomer";
import Setting from "./Components/Dashboard/Customer&Settings/settings";
import MountingSturcture from "./Components/MountingSturcture/mountingSturcture";
import ScrollToTop from "./scrollToTop";
import AdminSign from "./Components/adminDashboard/SignPage/adminSign";
import Electrical from "./Components/Dashboard/Electricals/electrical";
import Analytics from "./Components/Dashboard/Analytics/analytics";
import Financial from "./Components/Dashboard/Financials/financials";
import Admin from "./Components/Dashboard/Admin/Admin";
import DS from "./Components/Dashboard/Design&Structure/DS";
import CustomerAnalytics from "./Components/Sign/CustomerSupportInfo/customerAnalytics";
import AuthorizeUserRole from "./AuthorizeUserRole";
import Feedback from "./Components/Dashboard/Feedback/feedback";
import RequestDemoInfo from "./Components/Sign/CustomerSupportInfo/requestDemoInfo";
import Pricing from "./Components/PVX/Pricing/pricing";
import PVX from "./Components/PVX/Home/pvx";
import PvxAdmin from "./Components/pvxDashboard/Admin/pvxAdmin";
import FinancialOverview from "./Components/pvxDashboard/FinancialOverview/financialOverview";
import CustomerSupport from "./Components/pvxDashboard/CustomerSupport/customerSupport";
import SystemPerformance from "./Components/pvxDashboard/SystemPerformance/systemPerformance";
import UserEngagement from "./Components/pvxDashboard/UserEngagement/userEngagement";
import NotFoundComponent from "./pages/404";

import {
  SignIn,
  SignUp,
  Permission,
  Roles,
  Admins,
  Designers,
  Settings,
  Projects,
  Customer,
  SalesAdmin,
  Media,
  Requests,
  ForgetPassword
} from "./pages";
import SignUpMail from "./signUpMail";

function App() {
  const [isAuth, setIsAuth] = useState(false);
  console.log(isAuth);

  return (
    <div className="App" style={{ position: "relative" }}>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* SUPER ADMIN ROUTES */}
          <Route
            element={
              <AuthorizeUserRole allowedRoles={["SUPER"]}></AuthorizeUserRole>
            }
          >
            <Route path="/permissions" element={<Permission />}></Route>
            <Route path="/roles" element={<Roles />}></Route>
            <Route path="/admins" element={<Admins />}></Route>
            <Route path="/salesAdmins" element={<SalesAdmin />}></Route>
            <Route path="/media" element={<Media />}></Route>
          </Route>

          {/* Customer Request SIGNUP ROUTES */}
          <Route
            element={
              <AuthorizeUserRole
                allowedRoles={["SUPER", "SALES_ADMIN"]}
              ></AuthorizeUserRole>
            }
          >
            <Route path="/requests" element={<Requests />}></Route>
          </Route>

          {/* ADMIN ROUTES */}
          <Route
            element={
              <AuthorizeUserRole allowedRoles={["ADMIN"]}></AuthorizeUserRole>
            }
          >
            <Route path="/designers" element={<Designers />}></Route>
          </Route>

          {/* SALES_ADMIN Routes */}
          <Route
            element={
              <AuthorizeUserRole
                allowedRoles={["SALES_ADMIN"]}
              ></AuthorizeUserRole>
            }
          >
            <Route path="/customers" element={<Customer />}></Route>
          </Route>

          {/* COMMON ROUTES  */}
          <Route
            element={
              <AuthorizeUserRole
                allowedRoles={["DESIGNER", "ADMIN", "CUSTOMER"]}
              ></AuthorizeUserRole>
            }
          >
            <Route path="/dashboard" element={<Projects />}></Route>
            <Route
              path="/createProject"
              element={<CreateProject></CreateProject>}
            ></Route>
            <Route path="/analytics" element={<Analytics></Analytics>}></Route>
            <Route path="/design" element={<DS></DS>}></Route>
            <Route
              path="/electrical"
              element={<Electrical></Electrical>}
            ></Route>
            <Route path="/financial" element={<Financial></Financial>}></Route>
            <Route path="/summary" element={<Summary></Summary>}></Route>
          </Route>

          {/* Setting Route  */}
          <Route
            element={
              <AuthorizeUserRole
                allowedRoles={["SALES_ADMIN", "DESIGNER", "ADMIN", "CUSTOMER"]}
              ></AuthorizeUserRole>
            }
          >
            <Route path="/settings" element={<Settings />}></Route>
          </Route>

          {/*FORGET Password ROUTE */}
          <Route path="/password-reset" element={<ForgetPassword />} />

          {/* PVX Admin */}
          <Route path="/pvx-admin" element={<PvxAdmin />} />
          <Route
            path="/pvx-financial-overview"
            element={<FinancialOverview />}
          />
          <Route path="/pvx-customer-support" element={<CustomerSupport />} />
          <Route
            path="/pvx-system-performance"
            element={<SystemPerformance />}
          />
          <Route path="/pvx-user-engagement" element={<UserEngagement />} />
          <Route
            path="/mountingSturcture"
            element={<MountingSturcture></MountingSturcture>}
          ></Route>
          <Route
            path="/SignIn"
            element={<SignIn setIsAuth={setIsAuth}></SignIn>}
          ></Route>
          <Route
            path="/customerAnalytics"
            element={<CustomerAnalytics></CustomerAnalytics>}
          ></Route>
          <Route
            path="/requestDemoAnalytics"
            element={<RequestDemoInfo></RequestDemoInfo>}
          ></Route>
          <Route path="/customerFeedback" element={<Feedback />}></Route>
          {/* <Route path="/newCustomer" element={<SignUp></SignUp>}></Route> */}
          <Route path="/adminLogIn" element={<AdminSign></AdminSign>}></Route>

          <Route path="/request-signup" element={<SignUp></SignUp>} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/" element={<PVX />} />
          <Route path="/signUpMail" element={<SignUpMail />}></Route>

          {/* Customer Admin Pages */}
          <Route
            element={
              <AuthorizeUserRole allowedRoles={["adminn"]}></AuthorizeUserRole>
            }
          >
            <Route path="/admin" element={<Admin />}></Route>
            <Route
              path="/myCustomer"
              element={<MyCustomer></MyCustomer>}
            ></Route>
            <Route path="/newsettings" element={<Setting></Setting>}></Route>
          </Route>

          <Route
            path="/*"
            element={<NotFoundComponent></NotFoundComponent>}
          ></Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
